<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SNBAdmin from "../../../../layouts/nav/SNBAdmin.vue";
import JobFairCorpTabView from "./corp/JobFairCorpTabView.vue";
import JobFairStudentTabView from './student/JobFairStudentTabView.vue';

const route = useRoute();
const router = useRouter();
const tabRef = ref(null);

const tabOptions = [
  { label: '재직자/기업', value: 'company' },
  { label: '학생/취업준비생', value: 'student' },
];

const selectedTabValue = ref(tabOptions[0].value);

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set("tab", tab.value);
  queryParams.set("tab2", tab.value === 'company' ? "corp-info" : 'student-info');
  window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
};

onMounted(() => {
  const tabFromQuery = route.query.tab;
  if (tabFromQuery && tabOptions.some(opt => opt.value === tabFromQuery)) {
    selectedTabValue.value = tabFromQuery;

    if(tabRef.value) {
      tabRef.value.init(tabFromQuery);
    }
  }
});
</script>

<template>
  <div class="container">
    <div class="flex-wrap admin">
      <SNBAdmin class="snb" />
      <div class="content">
        <div class="sub-title">
          <h3>상시채용관 현황</h3>
        </div>
        <div class="tab-wrap">
          <KSATab 
            ref="tabRef"
            style="grid-template-columns: repeat(2, 1fr);" class="mb-sm"
            :options="tabOptions"
            @change="onChangeTab"
          />
        </div>
        <div v-if="selectedTabValue === 'company'">
          <JobFairCorpTabView />
        </div>
        <div v-else-if="selectedTabValue === 'student'">
          <JobFairStudentTabView />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 20px;
}
</style>